import React, { Component } from 'react';

export default class GroupsScannerOverlay extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {

        }
    }

    render() {

        return (
            <div className={"groups-scanner-overlay-outer" + (this.props.isScanMode ? "" : " hidden")}>
                <div className={"cancel-button"} onClick={this.props.stopScan}>{"Cancel"}</div>
                <div className={"inner-square-container"}>
                    <div className={"top-left"}></div>
                    <div className={"top-right"}></div>
                    <div className={"bottom-left"}></div>
                    <div className={"bottom-right"}></div>

                    <div className={"top-left inner"}></div>
                    <div className={"top-right inner"}></div>
                    <div className={"bottom-left inner"}></div>
                    <div className={"bottom-right inner"}></div>
                </div>
            </div>
        );
    }
}
